export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5286.c62f48bf.jpg";